// Copyright 2026, Auxilio Technologies LLC

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Shop {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  timezone?: string;
}

interface ShopState {
  shops: Shop[];
  activeShopId: string | null;
  setShops: (shops: Shop[]) => void;
  setActiveShop: (id: string) => void;
}

export const useShopStore = create<ShopState>()(
  persist(
    (set) => ({
      shops: [],
      activeShopId: null,
      setShops: (shops) =>
        set((s) => {
          const stillValid = s.activeShopId && shops.some((sh) => sh.id === s.activeShopId);
          return { shops, activeShopId: stillValid ? s.activeShopId : shops[0]?.id ?? null };
        }),
      setActiveShop: (id) => set({ activeShopId: id }),
    }),
    { name: 'optibloom-shop' }
  )
);

export function activeShop(): Shop | undefined {
  const { shops, activeShopId } = useShopStore.getState();
  return shops.find((s) => s.id === activeShopId);
}
